<template>
<div class="card">
    <div class="card-header">Open {{requestType}} Requests by Division</div>
    <div class="card-body">
        <b-table hover small responsive show-empty
            style="font-size:.80em;"
            :fields="fields"
            :items="openRequests"
            :busy="isLoading">
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>

            <template v-slot:empty="scope">
                <p>No data found</p>
            </template>
            <template #table-caption></template>
            <div slot="table-busy" class="text-center text-danger my-2">
                <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
                <strong>Loading, Please Wait...</strong>
            </div>  
        </b-table>
    </div>
</div>
</template>

<script>
import axios from "axios"

export default {
    components: { },
    props: { requestType: String},
    data() {
        return {
            isLoading: true,
            openRequests: [],
        }
    },
    computed: {       
        fields: function() {
            var results = [ ]
            results.push({key: 'phase', sortable: true, label: 'Phase'})
            results.push({key: 'responsible', sortable: true, label: 'Responsibility'})
            if (this.openRequests[0]) {
                for (var cnt in this.openRequests[0].divisionCounts) {
                    //console.log(cnt)
                    results.push({key: `divisionCounts.${cnt}`, sortable: true, label: cnt})
                }
            }
            results.push({key: 'total', sortable: true, label: 'Total'})
            return results
        } 
    },
    created() { 
        this.isLoading = true
        this.loadOpenRequestsByDivision();
    },
    watch: { },
    methods: {
        loadOpenRequestsByDivision() {
          if(this.requestType === 'Vacancy') {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/report/openByDivision`)
                .then(response => {
                  this.openRequests = this.processData(response.data, this.requestType)
                   console.log("OpenByDivision")
                   console.log(response.data)
                  this.isLoading = false
                })
          }
          if(this.requestType === 'Leave') {
            axios.get(`${process.env.VUE_APP_API_BASE_URL}/report/openLeaveByDivision`)
                .then(response => {
                  this.openRequests = this.processData(response.data, this.requestType)
                  console.log("OpenLeaveByDivision")
                  console.log(response.data)
                  this.isLoading = false
                })
          }
        },
        processData(data,requestType){
          var results = []
          var vacancyPhases = [
            'New',
            'Assigned',
            'Hold',
            'Audit',
            'Draft Posting',
            'Posted',
            'Screen Applicant',
            'Roster with Manager/Interview',
            'Salary Review',
            'Offered',
            'Background Check Pending',
            'Re-post',
            'Complete',
            'Pre Offer Review',
            'Cancelled']
          var leavesPhases =[
              'Approved',//02
              'Disapproved',//03
              'Leave Closed',//22
              'New',//01
          ]

          data.forEach(
              row =>{
                if(requestType === 'Leave' && leavesPhases.includes(row.phase)){
                  results.push(row)
                }
                else if(requestType === 'Vacancy' && vacancyPhases.includes(row.phase)){
                  results.push(row)
                }
              }
          )
          return(results)
        }
    }   
}
</script>